"use client";
import React from "react";
import { Link } from "react-router-dom";
import SocialIcon from "./SocialIcon";
import { socialLinks } from "../config/socialLinks";
import { getSiteContent, interpolate } from "../content/siteContent";

const iconColors = {
  telegram: "hover:border-sky-300/40 hover:bg-sky-400/10 hover:text-sky-200",
  whatsapp: "hover:border-emerald-300/40 hover:bg-emerald-400/10 hover:text-emerald-200",
  instagram: "hover:border-pink-300/40 hover:bg-pink-400/10 hover:text-pink-200",
};

export default function Footer() {
  const content = getSiteContent();
  const { common, contact, direction, footer } = content;
  const brandName = process.env.REACT_APP_BRAND_TITLE?.trim() || common.brandName;

  return (
    <footer className="relative z-20 border-t border-white/10 bg-slate-950/45 backdrop-blur-sm" dir={direction}>
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:grid-cols-2 lg:grid-cols-[1.5fr_0.8fr_1fr]">
        <div className="max-w-sm text-start">
          <Link to="/" className="inline-flex items-center gap-3 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-300">
            <img src="/logo.png" alt="" className="h-12 w-12 rounded-2xl object-cover ring-1 ring-cyan-300/30" />
            <span className="text-base font-black uppercase tracking-[0.18em] text-white">{brandName}</span>
          </Link>
          <p className="mt-4 text-sm leading-7 text-indigo-100/60">{footer.description}</p>
        </div>

        <nav className="text-start" aria-label={footer.explore}>
          <h2 className="text-xs font-black uppercase tracking-[0.25em] text-indigo-100/45">{footer.explore}</h2>
          <div className="mt-4 flex flex-col items-start gap-3 text-sm font-semibold text-indigo-100/70">
            <Link to="/" className="transition hover:text-white">{common.games}</Link>
            <Link to="/about" className="transition hover:text-white">{common.about}</Link>
            <Link to="/contact" className="transition hover:text-white">{common.contact}</Link>
            <Link to="/subscriptions" className="transition hover:text-white">{common.plans}</Link>
          </div>
        </nav>

        <div className="text-start">
          <h2 className="text-xs font-black uppercase tracking-[0.25em] text-indigo-100/45">{footer.connect}</h2>
          <div className="mt-4 flex flex-wrap gap-3">
            {socialLinks.map((social) => {
              const channel = contact.channels[social.id];
              const className = `grid h-11 w-11 place-items-center rounded-xl border border-white/10 bg-white/5 text-indigo-100/65 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-300 ${iconColors[social.id]}`;
              return social.url ? (
                <a
                  key={social.id}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  className={className}
                  aria-label={interpolate(common.openOn, { platform: channel.label })}
                  title={channel.label}
                >
                  <SocialIcon platform={social.id} />
                </a>
              ) : (
                <span
                  key={social.id}
                  className={`${className} cursor-not-allowed opacity-45`}
                  aria-label={`${channel.label}: ${common.comingSoon}`}
                  title={`${channel.label}: ${footer.unavailable}`}
                >
                  <SocialIcon platform={social.id} />
                </span>
              );
            })}
          </div>
          <Link to="/contact" className="mt-4 inline-block text-sm font-bold text-pink-200 transition hover:text-white">
            {common.contact}
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <p className="mx-auto max-w-6xl px-4 py-5 text-start text-xs uppercase tracking-[0.16em] text-indigo-100/40">
          © {new Date().getFullYear()} {brandName}. {footer.rights}
        </p>
      </div>
    </footer>
  );
}
